import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-wizard-step-blockchain',
  templateUrl: './wizard-step-blockchain.component.html',
  // Reusing the same CSS to keep it DRY
  styleUrls: ['../wizard-step-basic/wizard-step-basic.component.css'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class WizardStepBlockchainComponent {
  @Input() formGroup!: FormGroup;
}
